import { useState, useEffect } from "react"

import MedusaApiClient from "@lib/clients/medusa-api-client"
import NeloApiClient from "@lib/clients/nelo-api-client"
import { useAuthToken } from "@lib/hooks/use-auth-token"

export const useClientInitialization = () => {
  const authToken = useAuthToken()

  const [isInitialized, setIsInitialized] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const initializeClients = async () => {
      if (authToken) {
        try {
          NeloApiClient.setToken(authToken)
          MedusaApiClient.setToken(authToken)
          setIsInitialized(true)
        } catch (err) {
          setError(err instanceof Error ? err : new Error("An unknown error occurred"))
          console.error("Error initializing clients:", err)
        }
      } else {
        NeloApiClient.setToken()
        MedusaApiClient.setToken()
        setIsInitialized(false)
      }
    }

    initializeClients()
  }, [authToken])

  return { isInitialized, error }
}
